import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderSlider';
import { AppState } from '../../../../../types/store';
import { getSelectedFolderId } from '../../../../selectors/gallectionSection';
import { getFolders } from '../../../../selectors/folders';

export type StateProps = Pick<Props, 'folders' | 'selectedFolderId'>;
export type OwnProps = Without<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folders: getFolders(state),
  selectedFolderId: getSelectedFolderId(state),
});

export default connect(mapStateToProps);
